var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTestIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.8065C0 18.977 1.7629 20.7399 3.93345 20.7399C6.104 20.7399 7.8669 18.977 7.8669 16.8065C7.8669 14.6359 6.104 12.873 3.93345 12.873C1.7629 12.873 0 14.6359 0 16.8065Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9336 8.58204C8.46779 8.58204 12.1581 12.2723 12.1581 16.8065C12.1581 17.3965 12.6408 17.8793 13.2308 17.8793C13.8209 17.8793 14.3036 17.3965 14.3036 16.8065C14.3036 11.0887 9.6514 6.43652 3.9336 6.43652C3.34358 6.43652 2.86084 6.91926 2.86084 7.50928C2.86084 8.0993 3.34358 8.58204 3.9336 8.58204Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9336 2.14552C12.0186 2.14552 18.5946 8.72153 18.5946 16.8066C18.5946 17.3966 19.0774 17.8793 19.6674 17.8793C20.2574 17.8793 20.7402 17.3966 20.7402 16.8066C20.7402 7.53792 13.2022 0 3.9336 0C3.34358 0 2.86084 0.482741 2.86084 1.07276C2.86084 1.66278 3.34358 2.14552 3.9336 2.14552Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTestIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TestIcon.9b933e94.svg";
export { ForwardRef as ReactComponent };